// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  color: rgba(75, 75, 75, 1);
}
.login-cover-container {
  width: 60%;
  height: 100%;
}
.login-content-container {
  width: 40%;
  height: 100%;
}
.login-manual-token {
  text-align: center;
  cursor: pointer;
}
.login-logo-img {
  width: 100px;
  position: absolute;
  top: 30px;
  left: 30px;
}
.login-cover-img {
  position: absolute;
  bottom: 0;
  object-fit: cover;
  height: auto; /* 确保高度自动调整 */
  width: 60%;
  margin-left: 0px;
}
.login-option-box {
  width: 100%;
  height: calc(100% - 250px);
  display: flex;
  justify-content: center;
  /* align-items: center; */
}
.login-close-container {
  position: absolute;
  top: 30px;
  right: 30px;
}
.login-close-icon {
  font-size: 25px;
  opacity: 0.5;
  color: rgba(75, 75, 75, 1);
}
.login-content-illustration {
  width: 100px;
  margin-left: 40px;
  margin-top: 100px;
}
.login-title {
  font-size: 30px;
  line-height: 40px;
  font-weight: bold;
  margin: 28% 40px 20px 40px;
  color: #585858;
}
.login-subtitle {
  font-size: 18px;
  line-height: 27px;
  margin: 0 40px 20px 40px;
  color: #585858;
}
.login-next-button {
  width: 100px;
  height: 40px;
  border: 2px solid #585858;
  color: #585858;
  font-size: 17px;
  position: absolute;
  bottom: 30px;
  right: 30px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
}
.login-term {
  font-size: 12px;
  color: #585858;
  width: 300px;
  margin: 0 auto;
  margin-top: 0px;
  /* position: absolute;
  bottom: 10px; */
  text-align: center;
  padding: 10px;
  line-height: 14px;
}
.login-billing-info {
  font-size: 14px;
  color: #585858;
  width: 360px;
  margin: 0 auto;
  margin-top: -10px;
  margin-bottom: 10px;
  /* position: absolute;
  bottom: 10px; */
  text-align: center;
  padding: 10px;
  line-height: 18px;
}
.login-option-container {
  margin: 15px 0px;
  width: 260px;
  margin-left: calc(50% - 130px);
  height: 40px;
  border-radius: 20px;
  border: 2px solid #585858;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.login-region-container {
  margin: 0px 0px;
  width: 260px;
  margin-left: calc(50% - 130px);
  height: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.login-input-container {
  margin: 15px 0px;
  width: 260px;
  margin-left: calc(50% - 130px);
  height: 40px;
  border-radius: 20px;
  border: 2px solid #585858;
  position: relative;
  background-color: #f2ede5;
  padding-left: 10px;
  color: #585858;
  font-size: 15px;
}
.login-option-icon {
  margin: 10px;
  font-size: 17px;
}
.login-option-title {
  margin: 10px;
  width: calc(100%);
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-sync-box {
  /* border: 1px solid #585858; */
  border-radius: 15px;
  background-color: rgba(88, 88, 88, 0.1);
  width: 115px;
  height: 90px;
  position: relative;
  cursor: pointer;
}
.login-sync-text {
  font-size: 12px;
  line-height: 1.25;
  color: #585858;
  font-weight: bold;
  text-align: left;
  margin: 10px;
  margin-top: -5px;
}
.login-sync-container {
  width: 90%;
  height: 58%;
  overflow-y: scroll;
  margin: 0 auto;
  margin-top: -20px;
  /*实现三乘三的布局*/
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  grid-gap: 10px;
  /* padding: 10px; */
  align-items: center; /* 垂直居中 */
  justify-items: center; /* 水平居中 */
}
.login-sync-title {
  margin: 10px;
  width: calc(100% - 40px);
  font-size: 16px;
  color: #585858;
  text-align: left;
  /* font-weight: bold; */
}
.login-sync-support {
  display: inline;
  font-size: 15px;
  margin-left: 5px;
}
.login-sync-subtitle {
  padding: 10px;
  padding-bottom: 0px;
  width: calc(100% - 20px);
  font-size: 12px;
  color: #585858;
  opacity: 0.6;
  text-align: right;
  position: absolute;
  bottom: 10px;
  /* line-height: 20px; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.login-mobile-qr {
  width: 300px;
}
.login-mobile-container {
  width: 100%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-sync-icon {
  font-size: 10px;
  color: #fff;
}
.login-sync-icon-container {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #585858;
  position: absolute;
  top: 10px;
  right: 10px;
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/login.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,YAAY,EAAE,aAAa;EAC3B,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;EACf;iBACe;EACf,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB;iBACe;EACf,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;EACvC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;EACnB,mBAAmB,EAAE,SAAS;EAC9B,qBAAqB,EAAE,SAAS;AAClC;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;AACd","sourcesContent":[".login-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  color: rgba(75, 75, 75, 1);\n}\n.login-cover-container {\n  width: 60%;\n  height: 100%;\n}\n.login-content-container {\n  width: 40%;\n  height: 100%;\n}\n.login-manual-token {\n  text-align: center;\n  cursor: pointer;\n}\n.login-logo-img {\n  width: 100px;\n  position: absolute;\n  top: 30px;\n  left: 30px;\n}\n.login-cover-img {\n  position: absolute;\n  bottom: 0;\n  object-fit: cover;\n  height: auto; /* 确保高度自动调整 */\n  width: 60%;\n  margin-left: 0px;\n}\n.login-option-box {\n  width: 100%;\n  height: calc(100% - 250px);\n  display: flex;\n  justify-content: center;\n  /* align-items: center; */\n}\n.login-close-container {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n}\n.login-close-icon {\n  font-size: 25px;\n  opacity: 0.5;\n  color: rgba(75, 75, 75, 1);\n}\n.login-content-illustration {\n  width: 100px;\n  margin-left: 40px;\n  margin-top: 100px;\n}\n.login-title {\n  font-size: 30px;\n  line-height: 40px;\n  font-weight: bold;\n  margin: 28% 40px 20px 40px;\n  color: #585858;\n}\n.login-subtitle {\n  font-size: 18px;\n  line-height: 27px;\n  margin: 0 40px 20px 40px;\n  color: #585858;\n}\n.login-next-button {\n  width: 100px;\n  height: 40px;\n  border: 2px solid #585858;\n  color: #585858;\n  font-size: 17px;\n  position: absolute;\n  bottom: 30px;\n  right: 30px;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n.login-term {\n  font-size: 12px;\n  color: #585858;\n  width: 300px;\n  margin: 0 auto;\n  margin-top: 0px;\n  /* position: absolute;\n  bottom: 10px; */\n  text-align: center;\n  padding: 10px;\n  line-height: 14px;\n}\n.login-billing-info {\n  font-size: 14px;\n  color: #585858;\n  width: 360px;\n  margin: 0 auto;\n  margin-top: -10px;\n  margin-bottom: 10px;\n  /* position: absolute;\n  bottom: 10px; */\n  text-align: center;\n  padding: 10px;\n  line-height: 18px;\n}\n.login-option-container {\n  margin: 15px 0px;\n  width: 260px;\n  margin-left: calc(50% - 130px);\n  height: 40px;\n  border-radius: 20px;\n  border: 2px solid #585858;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n}\n.login-region-container {\n  margin: 0px 0px;\n  width: 260px;\n  margin-left: calc(50% - 130px);\n  height: 25px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n}\n.login-input-container {\n  margin: 15px 0px;\n  width: 260px;\n  margin-left: calc(50% - 130px);\n  height: 40px;\n  border-radius: 20px;\n  border: 2px solid #585858;\n  position: relative;\n  background-color: #f2ede5;\n  padding-left: 10px;\n  color: #585858;\n  font-size: 15px;\n}\n.login-option-icon {\n  margin: 10px;\n  font-size: 17px;\n}\n.login-option-title {\n  margin: 10px;\n  width: calc(100%);\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.login-sync-box {\n  /* border: 1px solid #585858; */\n  border-radius: 15px;\n  background-color: rgba(88, 88, 88, 0.1);\n  width: 115px;\n  height: 90px;\n  position: relative;\n  cursor: pointer;\n}\n.login-sync-text {\n  font-size: 12px;\n  line-height: 1.25;\n  color: #585858;\n  font-weight: bold;\n  text-align: left;\n  margin: 10px;\n  margin-top: -5px;\n}\n.login-sync-container {\n  width: 90%;\n  height: 58%;\n  overflow-y: scroll;\n  margin: 0 auto;\n  margin-top: -20px;\n  /*实现三乘三的布局*/\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: 1fr 1fr 1fr;\n  grid-gap: 10px;\n  /* padding: 10px; */\n  align-items: center; /* 垂直居中 */\n  justify-items: center; /* 水平居中 */\n}\n.login-sync-title {\n  margin: 10px;\n  width: calc(100% - 40px);\n  font-size: 16px;\n  color: #585858;\n  text-align: left;\n  /* font-weight: bold; */\n}\n.login-sync-support {\n  display: inline;\n  font-size: 15px;\n  margin-left: 5px;\n}\n.login-sync-subtitle {\n  padding: 10px;\n  padding-bottom: 0px;\n  width: calc(100% - 20px);\n  font-size: 12px;\n  color: #585858;\n  opacity: 0.6;\n  text-align: right;\n  position: absolute;\n  bottom: 10px;\n  /* line-height: 20px; */\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.login-mobile-qr {\n  width: 300px;\n}\n.login-mobile-container {\n  width: 100%;\n  height: 70%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.login-sync-icon {\n  font-size: 10px;\n  color: #fff;\n}\n.login-sync-icon-container {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  background-color: #585858;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
